import { useEffect } from 'react'
import { FiX } from 'react-icons/fi'
import type { IconType } from 'react-icons'

// Drawer lateral (desliza da direita) — mesmo conceito do financeiro do CRM
// (FinanceiroPanel.Modal). Substitui os modais flutuantes centralizados.
// Fecha no Esc e no clique do overlay. Header com ícone/título/subtítulo, corpo
// rolável e footer opcional pras ações.
export function SideModal({ title, subtitle, icon: Icon, onClose, children, footer, maxWidth = 'max-w-lg' }: {
  title: string
  subtitle?: string
  icon?: IconType
  onClose: () => void
  children: React.ReactNode
  footer?: React.ReactNode
  maxWidth?: string
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="fixed inset-0 z-[100000] flex justify-end">
      <div className="absolute inset-0 glass-overlay" onClick={onClose} />
      {/* PLANOS (21/10/2026): gaveta = cabeçalho de papel (ladrilho + título 18),
          corpo no CHÃO com as seções em caixas de papel (.pln-secao), rodapé de
          papel com as ações. Classes .pln-gaveta-* no fim do index.css. */}
      <div className={`pln-gaveta relative h-full w-full ${maxWidth} bg-background border-l border-border shadow-2xl neu-ledge-l neu-forms flex flex-col animate-slide-in-right`}>
        <div className="pln-gaveta-cab flex items-center gap-3 px-6 py-4 border-b border-border">
          {Icon && (
            <div className="pln-cab-icone shrink-0">
              <Icon />
            </div>
          )}
          <div className="min-w-0 flex-1">
            <h3 className="pln-gaveta-titulo">{title}</h3>
            {subtitle && <p className="pln-gaveta-sub">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="neu-tab w-9 h-9 flex items-center justify-center hover:bg-secondary rounded-lg text-muted-foreground transition-colors" title="Fechar (Esc)"><FiX className="w-[18px] h-[18px]" /></button>
        </div>
        <div className="pln-gaveta-corpo flex-1 overflow-auto scrollbar-thin px-6 py-5 space-y-4">{children}</div>
        {footer && <div className="pln-gaveta-rodape flex justify-end gap-2 px-6 py-4 border-t border-border">{footer}</div>}
      </div>
    </div>
  )
}
